import React from "react";
import styles from "./Customprogressbar.module.css";

const CustomProgressBar = ({
  steps = [],
  activeStep = 1,
  completedSteps = [],
}) => {
  return (
    <div className={styles.progressContainer}>
      {steps.map((item, index) => {
        const isCompleted = completedSteps.includes(item.step);
        const isActive = activeStep === item.step;
        const isLast = index === steps.length - 1;

        return (
          <React.Fragment key={item.step}>
            <div className={styles.stepWrapper}>
              <div
                className={`${styles.stepCircle} ${
                  isCompleted
                    ? styles.stepCompleted
                    : isActive
                      ? styles.stepActive
                      : styles.stepInactive
                }`}
              >
                {isCompleted ? (
                  <svg
                    className={styles.checkIcon}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  <span className={styles.stepNumber}>{item.step}</span>
                )}
              </div>
              <span
                className={`${styles.stepLabel} ${
                  isCompleted || isActive
                    ? styles.stepLabelActive
                    : styles.stepLabelInactive
                }`}
              >
                {item.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`${styles.connector} ${
                  isCompleted
                    ? styles.connectorCompleted
                    : styles.connectorInactive
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CustomProgressBar;
